export const MAP_DAY_ABBR_TO_FULL = {
  Mo: 'MONDAY',
  Tu: 'TUESDAY',
  We: 'WEDNESDAY',
  Th: 'THURSDAY',
  Fr: 'FRIDAY',
  Sa: 'SATURDAY',
  Su: 'SUNDAY',
};

export const MAP_DAY_FULL_TO_ABBR = Object.entries(MAP_DAY_ABBR_TO_FULL).reduce(
  (acc, [abbr, full]) => ({ ...acc, [full]: abbr }),
  {}
);
